import {Button} from 'platform/components';
import {Box, HStack, Icon, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

interface PendingChangesBarProps {
  title: string;
  isSaving: boolean;
  isSaveDisabled?: boolean;
  onDiscard: VoidFunction;
  onSave: VoidFunction;
}

/** Always renders — the caller decides when unsaved changes exist and the bar should show. */
export function PendingChangesBar(props: PendingChangesBarProps) {
  return (
    <Box position="sticky" left={0} right={0} bottom={4} paddingTop={4} pointerEvents="none">
      <Box
        width="100%"
        padding={4}
        backgroundColor="palettes.neutral.900.100"
        borderRadius="medium"
        boxShadow="elevation_3"
        pointerEvents="all"
      >
        <HStack justify="space-between" align="center" spacing={4} wrap>
          <HStack align="center" spacing={2}>
            <Icon value="alert/warning" color="severity.warning" size={4} />
            <Text color="white">{props.title}</Text>
          </HStack>
          <HStack align="center" spacing={2}>
            <Button
              title={i18n.t('general.actions.discardChanges')}
              variant="secondary"
              isDisabled={props.isSaving}
              onClick={props.onDiscard}
            />
            <Button
              title={i18n.t('general.actions.saveChanges')}
              isLoading={props.isSaving}
              isDisabled={props.isSaving || props.isSaveDisabled}
              onClick={props.onSave}
            />
          </HStack>
        </HStack>
      </Box>
    </Box>
  );
}
